import { useEffect, useState } from "react";

import firebase from "firebase/compat/app";

import { PersonalInformationDocument } from "./personal-information.model";

export const usePersonalInformation = (gardenerId: string | null | undefined) => {
    const [state, setState] = useState<PersonalInformationDocument | null>();

    useEffect(() => {
        if ( gardenerId === null ) return setState(null);
        if ( gardenerId === undefined ) return setState(undefined);

        setState(undefined);

        return firebase.firestore().collection("personalInformation").doc(gardenerId).onSnapshot(document => {
            if ( !document.exists ) return setState(null);

            setState({ id: document.id, ...document.data() } as PersonalInformationDocument);
        });
    }, [gardenerId]);

    return state;
};
